import { setLoading } from "redux/actions/app.actions";
import { openNotificationWithIcon } from "utils/Notification";
import { request } from "./verb.services";
import { getServerErrorString } from "utils/common";

export const getAllDeals = (showLoading = true) => {
    return (dispatch) => {
        if (showLoading) dispatch(setLoading(true));
        return request("Deals", "get", null, true, null)
            .then((res) => {
                return {
                    status: "success",
                    data: res.data,
                };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                if (showLoading) dispatch(setLoading(false));
            });
    };
};

export const getDeal = (id) => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return request(`Deals/${id}`, "get", null, true, null)
            .then((res) => {
                return {
                    status: "success",
                    data: res.data,
                };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};

export const createDeal = (values) => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return request(`Deals`, "post", values, true)
            .then((res) => {
                openNotificationWithIcon(
                    "success",
                    "Success",
                    "Deal created successfully"
                );
                return { status: "success", data: res?.data };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};

export const updateDeal = (id, data) => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return request(`Deals/${id}`, "put", data, true)
            .then(() => {
                openNotificationWithIcon(
                    "success",
                    "Success",
                    "Deal updated successfully"
                );
                return {
                    status: "success",
                };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};

export const deactivateDeal = (id) => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return request(`Deals/${id}/InActive`, "patch", null, true)
            .then(() => {
                openNotificationWithIcon(
                    "success",
                    "Success",
                    "Deal inactivated successfully"
                );
                return { status: "success" };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};

export const activateDeal = (id) => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return request(`Deals/${id}/Activate`, "patch", null, true)
            .then(() => {
                openNotificationWithIcon(
                    "success",
                    "Success",
                    "Deal activated successfully"
                );
                return { status: "success" };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};
